const HASH_LINK_REGEX = /href="#([^"]+)"/g

// İçerik HTML'inde `href="#kategori/slug"` biçimindeki eski hash linklerini
// gerçek route URL'lerine çeviren ve tıklamaları SPA navigasyonuyla
// yöneten yardımcı. v-html ile basılan article body'lerinde kullanılır.
export function useArticleHtml() {
  const router = useRouter()
  const config = useRuntimeConfig()
  const baseURL = trimTrailingSlash(config.app?.baseURL || '/')

  function transformHtml(html: string | undefined | null): string {
    if (!html) return ''
    return html.replace(HASH_LINK_REGEX, (match, path) => {
      // Yalnızca `kategori/slug` biçimini yeniden yaz; sayfa içi
      // anchor'lar (`#section-id`) ve mutlak path'ler dokunulmaz.
      if (!path || path.startsWith('/') || !path.includes('/')) return match
      return `href="${baseURL}/${path}"`
    })
  }

  function onArticleClick(event: MouseEvent) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.button !== 0) return

    const target = event.target as HTMLElement | null
    const anchor = target?.closest('a') as HTMLAnchorElement | null
    if (!anchor) return

    const href = anchor.getAttribute('href') || ''
    if (!href || !href.startsWith(`${baseURL}/`)) return
    if (anchor.target && anchor.target !== '_self') return

    event.preventDefault()
    const internalPath = href.slice(baseURL.length) || '/'
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
    }
    router.push(internalPath)
  }

  return { transformHtml, onArticleClick }
}
